<template>
    <div class="cart">
        <div v-if="cart_show">
            <div class="header">
                <span class="fs_32 c_ff">购物车</span>
                <div class="flex align-center" v-show="!edit_switch" @click="edit_switch=!edit_switch">
                    <span class="jcicon jcicon-bianji fs_36 c_ff"></span>
                    <span class="fs_28 c_ff">&nbsp;编辑</span>
                </div>
                <div class="flex align-center" v-show="edit_switch" @click="edit_switch=!edit_switch">
                    <span class="jcicon jcicon-chenggong- fs_30 c_ff"></span>
                    <span class="fs_28 c_ff">&nbsp;完成</span>
                </div>
            </div>
            <div class="header-layer"></div>
            <!-- 商品列表 -->
            <div class="modular">
                <div>
                    <div class="flex modular__item" v-for="(item,index) in effective_cart" :key="index">
                        <div class="flex__center__center checkbox__item">
                            <van-checkbox v-model="item.is_select" checked-color="#F93A42" @change="setSingle(index)"></van-checkbox>
                        </div>
                        <div class="flex modular__item__info">
                            <img :src="item.cover_img" alt="" v-link="'/Mall/Detail/'+item.product_id">
                            <div class="flex__null__around modular__item__right">
                                <span class="fs_26 c_1a lh_36 ellipsis_two" v-link="'/Mall/Detail/'+item.product_id">{{item.name}}</span>
                                <span class="fs_22 c_98" v-if="item.product_sku_name">规格:{{item.product_sku_name}}</span>
                                <div class="flex__between__center">
                                    <span class="c_main fs_30"><span class="fs_22">¥</span>{{item.price}}</span>
                                    <div class='stepper_components'>
                                        <div class='count' @click.stop='reduce(index)'>
                                            <span class='jcicon jcicon-jianhaocu c_4d fs_22'></span>
                                        </div>
                                        <div class='count count--big'>
                                            <span class='fs_24'>{{item.number}}</span>
                                        </div>
                                        <div class='count' @click.stop='add(index)'>
                                            <span class='jcicon jcicon-jiahao c_4d fs_22'></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
                <!-- 失效商品列表 -->
                <div class="mt_20" v-if="invalid_cart.length">
                    <div class="flex__between modular__title">
                        <span class="fs_28 c_66">失效宝贝{{invalid_cart.length}}件</span>
                        <span class="fs_28 c_main" @click="clear">清空失效宝贝</span>
                    </div>
                    <div class="flex modular__item" v-for="(item,index) in invalid_cart" :key="index">
                        <div class="modular__item-layer"></div>
                        <div class="flex__center__center checkbox__item">
                            <span class="invalid-box">失效</span>
                        </div>
                        <div class="flex modular__item__info">
                            <img :src="item.cover_img" alt="">
                            <div class="flex__null__around modular__item__right">
                                <span class="fs_26 c_1a lh_36 ellipsis_two">{{item.name}}{{item.name}}</span>
                                <span class="fs_22 c_98" v-if="item.product_sku_name">规格:{{item.product_sku_name}}</span>
                                <span class="c_main fs_30"><span class="fs_22">¥</span>{{item.price}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 底部操作栏 -->
            <div class="flex__between__center footer">
                <div class="flex__between__center footer__left">
                    <van-checkbox v-model="is_all" checked-color="#F93A42" @change="setAll"></van-checkbox>
                    <span class="fs_32 c_4d">&ensp;全选</span>
                </div>
                <div class="flex align-center">
                    <div>
                        <span class="fs_28 c_4d">合计：</span>
                        <span class="c_main fs_24">¥</span>
                        <span class="c_main fs_32">{{total_money}}</span>
                    </div>
                    <button class="cancel" @click="del" v-show="edit_switch">删除&ensp;({{total_number}})</button>
                    <button class="cancel" @click="balance" v-show="!edit_switch">结算&ensp;({{total_number}})</button>
                </div>
            </div>
        </div>
        <div class="nothing-box flex__center__center" v-else>
            <div class="flex__center__around">
                <img src="@/assets/images/nothing.png" alt="">
                <p class="fs_32 c_4d mt_30">你的购物车竟然是空的</p>
            </div>
        </div>
        <tab-bar :current='2'></tab-bar>
    </div>
</template>
<script>
export default {
    name:'Cart',
    data(){
        return{
            cart_show: true, //购物车缺省
            edit_switch: false, //是否全选
            is_all: 0, //是否全选
            cart_id: '', //购物车操作id
            effective_cart: [],
            invalid_cart: [],
            total_number: 0,
            total_money: ''
        }
    },
    methods:{
        // 获取数据
        load(){
            this.axios.post('/wechat.php/Mall/getCartData',{
                user_id: localStorage.user_id
            }).then(
                res=>{
                    if(res.data.code==1){
                        this.effective_cart=res.data.data.effective_cart;
                        this.invalid_cart=res.data.data.invalid_cart;
                        this.total_money=res.data.data.total_money;
                        this.total_number=res.data.data.total_number;
                    }
                }
            )
        },
        // 减
        reduce(index){
            if(this.effective_cart[index].number==1){
                this.$toast('最少购买1件哦！')
                return;
            }
            // this.effective_cart[index].number=this.effective_cart[index].number-1;
            let goods=this.effective_cart[index];
            this.axios.post('/wechat.php/Mall/updateCart',{
                user_id: localStorage.user_id,
                product_id: goods.product_id,
                number: goods.number,
                sku: goods.product_sku
            }).then(
                res=>{
                    if(res.data.code==1){
                        this.effective_cart[index].number--;
                        if(!goods.number){
                            this.load();
                            this.$toast(res.data.message);
                        }
                        this.total_money=res.data.data.total_money;
                        this.total_number=res.data.data.total_number;
                    }else if(res.data.code==203){
                        this.effective_cart[index].number--;
                    }else{
                        this.$toast(res.data.message);
                    }
                }
            )
        },
        // 加
        add(index){
            // this.effective_cart[index].number=this.effective_cart[index].number+1;
            let goods=this.effective_cart[index];
            this.axios.post('/wechat.php/Mall/updateCart',{
                user_id: localStorage.user_id,
                product_id: goods.product_id,
                number: goods.number,
                sku: goods.product_sku
            }).then(
                res=>{
                    if(res.data.code==1){
                        this.effective_cart[index].number++;
                        this.total_money=res.data.data.total_money;
                        this.total_number=res.data.data.total_number;
                    }else{
                        this.$toast(res.data.message);
                    }
                    
                }
            )
        },
        // 全选
        setAll(){
            for(let i=0;i<this.effective_cart.length;i++){
                if(this.is_all){
                    this.effective_cart[i].is_select=1;
                }else{
                    this.effective_cart[i].is_select=0;
                }
            }
            console.log(this.effective_cart);
            this.axios.post('/wechat.php/Mall/updateCartAll',{
                user_id: localStorage.user_id,
                is_select: this.is_all
            }).then(
                res=>{
                    if(res.data.code==1){
                        this.total_money=res.data.data.total_money;
                        this.total_number=res.data.data.total_number;
                    }else{
                        this.$toast(res.data.message);
                    }
                }
            )
        },
        // 单个复选框
        setSingle(index){
            this.axios.post('/wechat.php/Mall/updateCartSelect',{
                user_id: localStorage.user_id,
                cart_id: this.effective_cart[index].id,
                is_select: this.effective_cart[index].is_select
            }).then(
                res=>{
                    if(res.data.code==1){
                        this.total_money=res.data.data.total_money;
                        this.total_number=res.data.data.total_number;
                    }else{
                        this.$toast(res.data.message);
                    }
                }
            )
        },
        // 删除
        del(){
            if(this.cart_id){
                this.axios.post('/wechat.php/Mall/deleteCart',{
                    user_id: localStorage.user_id,
                    cart_id: this.cart_id
                }).then(
                    res=>{
                        if(res.data.code==1){
                            this.load();
                        }
                        this.$toast(res.data.message);
                    }
                )
            }else{
                this.$toast('您未选中宝贝');
            }
        },
        // 清楚无效商品
        clear(){
            this.axios.post('/wechat.php/Mall/deleteInvalid',{
                user_id: localStorage.user_id
            }).then(
                res=>{
                    if(res.data.code==1){
                        this.load();
                    }
                    this.$toast(res.data.message);
                }
            )
        },
        // 结算
        balance(){
            if (this.total_number) {
                this.axios.post('/wechat.php/Mall/verificationStock',{
                    user_id: localStorage.user_id
                }).then(
                    res=>{
                        if(res.data.code==1){
                            this.$router.push({
                                path:'/Mall/Order',
                                query: {
                                    settlement_type:1
                                }
                            })
                        }else{
                            this.$toast(res.data.message)
                        }
                    }
                ).catch(
                    res=>{
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }else{
                this.$toast("请选择商品")
            }
        }
    },
    mounted(){
        this.load();
    },
    watch: {
        effective_cart:{
            handler(newVal, oldVal){
                console.log(newVal)
                let all_arr=[];
                if(newVal.length){
                    this.cart_show=true;
                    for(let i=0;i<newVal.length;i++){
                        if(newVal[i].is_select){
                            all_arr.push(newVal[i].id);
                        }
                    }
                    this.cart_id=all_arr.join(',');
                    if(all_arr.length==newVal.length){
                        this.is_all=1;
                    }else{
                        this.is_all=0;
                    }
                }else{
                    this.cart_show=false;
                    this.is_all=0;
                }
            },
            deep: true
        }
    }
}
</script>
<style scoped>
    /* 无内容 */
    .nothing-box{
        position: fixed;
        top: 0;
        bottom: 98px;
        width: 100%;
        background: #fff;
    }
    .nothing-box img{
      width: 200px;
      height: 200px;
    }
    .header{
        position: fixed;
        z-index: 2;
        width: 100%;
        height: 90px;
        padding: 0 30px;
        background: #F93A42;
        text-align: center;
        line-height: 90px;
    }
    .header-layer{
        position: fixed;
        top: 90px;
        width: 100%;
        height: 220px;
        background: #F93A42;
    }
    .header>div{
        position: absolute;
        top: 0;
        right: 30px;
    }
    /* 商品列表 */
    .modular{
        position: relative;
        z-index: 1;
        padding: 90px 20px 98px;
    }
    .modular__title{
        padding: 30px;
        border-radius: 10px 10px 0 0;
        border-bottom: 2px solid #e6e6e6;
        background: #fff;
    }
    .modular__item{
        position: relative;
        width: 710px;
        height: 240px;
        padding: 30px;
        background: #fff;
        border-bottom: 2px solid #e6e6e6;
    }
    .modular__item__info{
        position: absolute;
        left: 80px;
    }
    .modular__item__right{
        width: 390px;
        margin-left: 30px;
    }
    .modular__item-layer{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background: rgba(255,255,255,0.4);
    }
    .modular__item:first-child{
        border-radius: 10px 10px 0 0;
    }
    .modular__item:last-child{
        border-radius: 0 0 10px 10px;
        border: 0;
    }
    .modular__item img{
        width:180px;
        height:180px;
        border-radius:10px;
    }
    .checkbox__item{
        position: absolute;
        left: 0;
        /* flex-shrink: 0; */
        width: 80px;
        height: 180px;
    }
    .invalid-box{
        height: 30px;
        padding: 0 12px;
        background: #cbcbcb;
        line-height: 30px;
        font-size: 22px;
        color: #fff;
        border-radius: 30px;
    }
    /* footer */
    .footer{
        position: fixed;
        width: 100%;
        bottom: 98px;
        z-index: 3;
        height: 98px;
        background: #fff;
    }
    .footer__left{
        padding: 0 30px;
    }
    .cancel{
        width: 250px;
        height: 98px;
        margin-left: 30px;
        background: #F93A42;
        color: #fff;
        font-size: 32px;
    }
    /* 计步器 */
    .stepper_components{
        display: flex;
        justify-content: space-between;
        width: 180px;
        height: 50px;
        border: 2px solid #e6e6e6;
        border-radius: 10px;
    }
    .stepper_components .count{
        width: 54px;
        height: 46px;
        line-height: 46px;
        text-align: center;
    }
    .stepper_components .count--big{
        width: 70px;
        height: 46px;  
        border-right: 2px solid #e6e6e6;
        border-left: 2px solid #e6e6e6;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/pages/mall/Cart.vue